<div class="p-2 alert" [class]="'alert_'+type">
  @if (showIcon) {
    <epmax-icon [color]="type" [size]="20" [name]="iconName"></epmax-icon>
  }
  <epmax-typo [weight]="400" [color]="type" [name]="'body1'">{{label | translate}}</epmax-typo>
</div>
